<template>
    <div style="position:relative;height:100%;">
     <div class="flex-wrap" style="width:100%;height:30px;font-weight:bold;">
       <BaseIcon icon="md-apps" style="margin-right:5px" />合同付款  <div style="font-weight:normal;margin-left:10px;">2024 <BaseIcon icon="ios-arrow-down" /></div> </div>


       <div class="flex-wrap align-start" style="height:calc(100% - 30px);flex-wrap:wrap;gap:5px 5px;align-content:flex-start;">
         <div  class="flex-wrap flex-between" style="background:var(--bg3);padding:5px 10px;border-radius:3px;width:calc(60% - 5px);height:70px;">
            <div>
            <div><span style="color:var(--text3);font-size:20px;font-weight:bold;">32.6</span> <span style="font-size:12px">万元</span></div>
            <div style="font-size:12px;">已支付</div>
        </div>
        <div class="flex-wrap">
            <i-circle :percent="84" style="width:45px;height:45px;"
            :trail-width="10" :stroke-width="8" stroke-color="var(--primary)">
                <div style="font-size:12px">83%</div>
            </i-circle>
        </div>

         </div>
         <div class="flex-wrap flex-between" style="font-size:25px;background:var(--bg3);padding:5px 15px;border-radius:3px;width:calc(40%);overflow:hidden;height:70px;">
            <div>
                <span style="color:var(--primary);font-size:20px;font-weight:bold;">0.32</span> <span style="font-size:12px">万元</span>
            <div style="font-size:12px;">未支付</div>
        </div>

         </div>


        <div style="font-size:14px;background:var(--bg3);border-radius:3px;width:calc(100%);height:300px">
            <template v-for="item in items">
                <Row  style="padding:10px;border-bottom:1px solid var(--border)" :key="item.id" align="middle" :gutter="10">
                    <Col :span="4" style="font-size:13px;color:var(--success);text-align:center;font-weight:bold;">{{ item.date }}</Col>
                   <Col :span="13"> <div style="color:var(--primary);font-weight:bold;">{{ item.name }}</div>
                   <div style="font-size:12px">{{ item.node }} / <span style="color:var(--subtext3)">{{ item.note }}</span> </div></Col>
                   <Col :span="6" align="end"><BaseAmount :value="item.amount" /></Col>
                </Row>
            </template>
        </div>

      </div>
     </div>

 </template>

<script>
import PieChart from '@/components/charts/piecharts';
export default {
  components: {PieChart},
  data() {
    return {
      chart1: {
        name: '新签合同',
        data: [
          {value: 148, name: '全过程咨询'},
          {value: 335, name: '房建监理'},
          {value: 280, name: '市政监理'},
          {value: 184, name: '造价咨询'},
          {value: 300, name: '招标代理'},
        ],
      },
      chart2: {
        name: '履约合同',
        data: [
          {value: 1048, name: '全过程咨询'},
          {value: 735, name: '房建监理'},
          {value: 580, name: '市政监理'},
          {value: 484, name: '造价咨询'},
          {value: 300, name: '招标代理'},
        ],
      },
      items: [{
        name: '知识产权服务合同',
        node: '成功上报后支付',
        note: '2024软著4份',
        date: '05/03',
        amount: '3200',
        state: '草稿',
      }, {
        name: '钉钉采购合同',
        node: '线上付款',
        date: '04/12',
        note: '会员费用',
        amount: '9999',
        state: '付款中',
      }],
    };
  },
};
</script>

 <style>

 </style>
